import {
  ScreenerSettingName,
  useScreenerSettingsQuery
} from '@/pages/CRM/Screener/hooks/useScreenerSettingsQuery';
import { ExacareFeature, FeatureFlagService } from '@/utils/featureFlagService';

interface UseCrmEsignAvailabilityOptions {
  enabled?: boolean;
}

/** @deprecated Use `useScreenerSetting<'enabled' | 'disabled'>('esign_enabled', facilityId)` from `src/hooks/screener-settings` instead. Compose the LaunchDarkly flag at the call site. */
export function useCrmEsignAvailability(
  options: UseCrmEsignAvailabilityOptions = {}
) {
  const featureFlagEnabled = FeatureFlagService.isEnabled(
    ExacareFeature.CRM_ESIGN
  );
  const queryEnabled = (options.enabled ?? true) && featureFlagEnabled;
  const { useFindOne } = useScreenerSettingsQuery();
  const orgEnabledQuery = useFindOne(
    {
      settingName: ScreenerSettingName.EsignEnabled
    },
    {
      enabled: queryEnabled
    }
  );

  return {
    isEnabled: queryEnabled && orgEnabledQuery.data?.data?.value === 'enabled',
    isLoading: queryEnabled && orgEnabledQuery.isLoading
  };
}
